<template>
	<div class="main-content-wrapper reward matches">
    <CreateGameWrapper @saveGame="saveGame"></CreateGameWrapper>
  </div>
</template>
<script>
import CreateGameWrapper from '@/components/fantasyconsole/CreateGameWrapper'

export default {
  components: {
    CreateGameWrapper
  },

  data () {
    return {
      contestKey: this.$route.params.key
    }
  },

  mounted () {
  },

  methods: {
    saveGame () {
      if (this.contestKey) {
        this.$router.push({name: 'FCEditContest', params: {'key': this.contestKey}})
      }
    }
  } 
}
</script>
